module.exports = __webpack_public_path__ + "img/Flag_of_South_Georgia_and_the_South_Sandwich_Islands.3b66e2cd.svg";